import {
  getGroupChatDetail,
  dismissGroupChat,
  exitGroupChat,
} from '@/api/group-chat';
import { GROUP_CHAT_ALL_MEMBER } from '_lib/constants/group-chat';
import { IM_MSG_TYPE, IM_RECEIVE_TYPE } from '@/common/constants/IM.ts';
import store from '@/store';
import Vue from 'vue';
import router from '@/router';
import { GROUP_CHAT_UNIVERSAL_TIP_TYPES } from '@/views/room/IM/MessageList/components/GroupChatUniversalMessage/constants';
import { ROOM_NOTIFY_SETTING_ENUM } from '_lib/constants/room';
import ChatGroupPermission from '_lib/ChatGroupPermission';
import { CHAT_GROUP_PERMISSION_KEY_NAMES } from "@/common/constants/group-chat";

/**
 * 进入群聊
 * @param {string} chatGroupId
 * @param {Function | undefined} cb
 */
export const enterGroupChat = async (chatGroupId, cb) => {
  const clearRecentMsg = () => {
    const recentMsgList = store.getters.recent_msg_list;
    const targetIndex = recentMsgList.findIndex(
      (item) => item.user_id == chatGroupId
    );
    if (targetIndex > -1) {
      recentMsgList.splice(targetIndex, 1);
      store.commit('SET_RECENT_MSG_LIST', recentMsgList);
    }
  };

  const {
    data: { status, result },
  } = await getGroupChatDetail({
    chat_group_id: chatGroupId,
  }).catch(() => {
    clearRecentMsg();
    return;
  });
  if (status === 'ok') {
    // 如果被封禁了，则需要弹出封禁弹窗
    if (result.chat_group_ban) {
      handleChatGroupBan(chatGroupId, result.chat_group_ban);
      return;
    }
    if (router.currentRoute.name !== 'friends') {
      await router.push({ name: 'friends' });
    }
    store.commit('SET_CUR_GROUP_CHAT', result);
    cb && cb();
  } else {
    clearRecentMsg();
    return;
  }
};

/**
 * 计算是否是群聊艾特自己
 * @param {*} msg
 * @returns
 */
export const calcIsGroupAtMe = (msg) => {
  if(msg.receive_type !== IM_RECEIVE_TYPE.chat_group) {
    return false;
  }
  return (
    (msg.msg_type === IM_MSG_TYPE.AtOrChannel &&
      msg.at_users &&
      msg.at_users.some((v) => v.user_id == store.getters.user_info.user_id)) ||
    (msg.at_roles &&
      msg.at_roles.some((v) => v.role_id == GROUP_CHAT_ALL_MEMBER) &&
      msg.user_id != store.getters.user_info.user_id)
  );
};

/**
 * 处理群聊封禁
 * @param {object} chatGroupBan
 * @param {string} chatGroupId
 */
export const handleChatGroupBan = (chatGroupId, chatGroupBanInfo) => {
  store.commit('SET_CUR_GROUP_CHAT', {});
  const { create_by, desc, high_light, title, joined } = chatGroupBanInfo;

  const getHighLightDesc = (desc, high_light) => {
    return desc.replace(
      high_light,
      `<span class="text-tx-1">${high_light}</span>`
    );
  };

  let cancelBtn = undefined;
  let confirmBtn = {
    text: '我知道了',
  };
  let isOwner = false;
  if (joined) {
    isOwner = create_by == store.getters.user_info.user_id;
    cancelBtn = {
      text: '我知道了',
    };
    confirmBtn = {
      text: isOwner ? '删除群聊' : '退出群聊',
      type: 'alert',
    };
  }

  Vue.prototype.$query({
    config: {
      title: title,
      desc: getHighLightDesc(desc, high_light),
      confirm: confirmBtn,
      cancel: cancelBtn,
    },
    confirmCB: async () => {
      if (joined) {
        const api = isOwner ? dismissGroupChat : exitGroupChat;
        const {
          data: { status },
        } = await api({}, { chat_group_id: chatGroupId });
        if (status === 'ok') {
          const recentMsgList = store.getters.recent_msg_list;
          const targetIndex = recentMsgList.findIndex(
            (item) => item.user_id == chatGroupId
          );
          if (targetIndex > -1) {
            recentMsgList.splice(targetIndex, 1);
            store.commit('SET_RECENT_MSG_LIST', recentMsgList);
          }
        }
      }
    },
  });
};

/**
 * 判断是否为进群申请消息
 * @param {*} msg
 * @returns
 */
export const calcIsGroupHasPendingApproval = (msg) => {
  if(msg.receive_type !== IM_RECEIVE_TYPE.chat_group) {
    return false;
  }
  if(msg.chat_group_id !== store.getters.cur_group_chat.chat_group_info?.chat_group_id) {
    return false;
  }
  const { tip_actions = {} } = msg;
  const { tip_type } = tip_actions;
  return tip_type === GROUP_CHAT_UNIVERSAL_TIP_TYPES.apply_join;
};


/**
 * 判断是否为群公告消息
 * @param {*} msg 
 * @returns 
 */
export const calcIsHasGroupAnnouncement = (msg) => {
  if(msg.receive_type !== IM_RECEIVE_TYPE.chat_group) {
    return false;
  }
  return msg.msg_type === IM_MSG_TYPE.groupAnnouncement;
};

